module.exports = __webpack_public_path__ + "img/yanzheng.40e2c406.png";